<template>
  <div class="invoice-by-customer-report">
    <v-card flat class="report-page-card">
      <ReportViewBar
        :title="title"
        :start="start"
        :end="end"
        :export-data="exportData"
        :export-fields="exportFields"
      />

      <v-card-text class="report-content">
        <InvoiceByCustomer
          :start="start"
          :end="end"
          @export-data="setExportData"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import ReportViewBar from "@/components/ReportViewBar";

const InvoiceByCustomer = () =>
  import("@/modules/ReportView/GlobalReport/SaleByCustomers.vue");

export default {
  name: "invoice-by-customer-report",

  components: {
    ReportViewBar,
    InvoiceByCustomer,
  },

  props: {
    title: {
      type: String,
      default: "Invoice By Customer",
    },
  },

  data() {
    return {
      start: null,
      end: null,
      exportData: [],
      exportFields: {
        Customer: "customerName",
        Sale: "totalSale",
      },
    };
  },

  created() {
    this.start = this.$route.query.start || null;
    this.end = this.$route.query.end || null;
  },

  methods: {
    setExportData(rows) {
      this.exportData = rows || [];
    },
  },
};
</script>

<style scoped>
.invoice-by-customer-report {
  background: #f5f7fb;
  min-height: 100vh;
  padding: 16px;
}

.report-page-card {
  border-radius: 18px;
  overflow: hidden;
}

.report-content {
  padding: 20px;
}

@media print {
  .invoice-by-customer-report {
    background: #fff;
    padding: 0;
  }

  .report-page-card {
    box-shadow: none !important;
    border-radius: 0;
  }

  .report-content {
    padding: 0;
  }

  .no-print {
    display: none !important;
  }
}
</style>